module.exports = __webpack_public_path__ + "img/vector-polygon.83fa9e8c.svg";